import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import Button from '../../../../../ui/canon/Button';
import { CheckIcon, SendIcon } from 'lucide-react';

const ChecklistWidget = ({ options = [], onAnswer, disabled, initialValue = [] }) => {
  const intl = useIntl();
  // Normalize options to handle both string[] and {label, value}[] formats
  const normalizedOptions = (options || []).map(opt => {
    if (typeof opt === 'string') {
      return { label: opt, value: opt };
    }
    // Handle {label, value} objects
    return { label: opt.label || opt.value || String(opt), value: opt.value || opt.label || String(opt) };
  });

  const getInitialSelected = () => {
    if (!initialValue) return [];
    if (Array.isArray(initialValue)) return initialValue;
    return [initialValue];
  };
  
  const [selected, setSelected] = useState(getInitialSelected);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    setSelected(getInitialSelected());
    setIsSubmitting(false);
  }, [initialValue]);

  const handleToggle = (value) => {
    if (selected.includes(value)) {
      setSelected(selected.filter(s => s !== value));
    } else {
      setSelected([...selected, value]);
    }
  };

  const handleSubmit = () => {
    if (!isSubmitting) {
      setIsSubmitting(true);
      onAnswer({ value: selected });
    }
  };

  return (
    <div className="space-y-2.5">
      <p className="text-xs text-succession-text-muted">{intl.formatMessage({ id: 'succession.plans.widget_checklist_hint' })}</p>
      <div className="space-y-1.5">
        {normalizedOptions.map((option) => (
          <div
            key={option.value}
            onClick={() => !disabled && !isSubmitting && handleToggle(option.value)}
            className={`flex items-center py-2 px-2.5 rounded border cursor-pointer transition-colors ${
              selected.includes(option.value)
                ? 'bg-succession-primary/10 border-succession-primary'
                : 'bg-succession-bg-primary border-succession-border hover:border-succession-primary/50'
            }`}
          >
            <div className={`w-4 h-4 rounded border flex items-center justify-center mr-2.5 flex-shrink-0 ${
              selected.includes(option.value) ? 'bg-succession-primary border-succession-primary' : 'border-succession-border'
            }`}>
              {selected.includes(option.value) && <CheckIcon className="h-2.5 w-2.5 text-white" />}
            </div>
            <span className="text-xs text-succession-text-primary">{option.label}</span>
          </div>
        ))}
      </div>
      <Button
        onClick={handleSubmit}
        disabled={selected.length === 0 || disabled || isSubmitting}
        className="w-full text-sm"
        size="sm"
      >
        <SendIcon className="h-3.5 w-3.5 mr-2" />
        {intl.formatMessage({ id: 'succession.plans.widget_submit_answer' })}
      </Button>
    </div>
  );
};

export default ChecklistWidget;
